export default __webpack_public_path__ + "static/6-9636105e05b14719b50a5311138b4d11.jpg";